import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Global_variable } from '../global_variables';
import { map, catchError } from 'rxjs/operators';

import { Panneau } from '../models/panneau.model';

export type EntityResponseType = HttpResponse<Panneau>;

@Injectable()
export class PanneauxService {

    private resourceUrl =  this.global_variable.baseUrl + "/supports";
    private resourceUrl2 =  this.global_variable.baseUrl + "/supports_valide";
    private resourceUrl3 =  this.global_variable.baseUrl + "/supports_latest";

    constructor(private http: HttpClient, private global_variable: Global_variable) { }

    create(panneau: Panneau): Observable<EntityResponseType> {
        const copy = this.convert(panneau);
        return this.http.post<Panneau>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    update(panneau: Panneau): Observable<EntityResponseType> {
        const copy = this.convert(panneau);
        return this.http.put<Panneau>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    findById(id: number): Observable<EntityResponseType> {
        return this.http.get<Panneau>(`${this.resourceUrl}/${id}`, { observe: 'response'})
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    findByName(name: string): Observable<EntityResponseType> {
        return this.http.get<Panneau>(`${this.resourceUrl}/name/${name}`, { observe: 'response'})
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    get_latest(): Observable<EntityResponseType> {
        return this.http.get<Panneau>(`${this.resourceUrl3}`, { observe: 'response'})
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    findByImei(imei: string): Observable<EntityResponseType> {
        return this.http.get<Panneau>(`${this.resourceUrl}/imei/${imei}`,  { observe: 'response'})
            .pipe(map((res: EntityResponseType) => this.convertResponse(res)));
    }

    query(req?: any): Observable<HttpResponse<Panneau[]>> {
        return this.http.get<Panneau[]>(this.resourceUrl, { observe: 'response' })
            .pipe(map((res: HttpResponse<Panneau[]>) => this.convertArrayResponse(res)));
    }
    get_panneaux_valide(req?: any): Observable<HttpResponse<Panneau[]>> {
        return this.http.get<Panneau[]>(this.resourceUrl2, { observe: 'response' })
            .pipe(map((res: HttpResponse<Panneau[]>) => this.convertArrayResponse(res)));
    }


    get_panneau_regie( id : number ):Observable<HttpResponse<Panneau[]>> {
        return this.http.get<Panneau[]>(`${this.resourceUrl}/regie/${id}`, { observe: 'response' })
            .pipe(map((res: HttpResponse<Panneau[]>) => this.convertArrayResponse(res)));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response'});
    }

    private convertResponse(res: EntityResponseType): EntityResponseType {
        const body: Panneau = this.convertItemFromServer(res.body);
        return res.clone({body});
    }

    private convertArrayResponse(res: HttpResponse<Panneau[]>): HttpResponse<Panneau[]> {
        const jsonResponse: Panneau[] = res.body;
        const body: Panneau[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }
        return res.clone({body});
    }

     /*Convert a returned JSON object to Panneau.*/
     
    private convertItemFromServer(panneau: Panneau): Panneau {
        const copy: Panneau = Object.assign({}, panneau);
        return copy;
    }

    
    /* Convert a Panneau to a JSON which can be sent to the server.*/
         private convert(panneau: Panneau): Panneau {
        const copy: Panneau = Object.assign({}, panneau);
        return copy;
    }
}



